export type UtmParams = {
  utm_source: string
  utm_medium: string
  utm_campaign: string
  utm_content?: string
}

export function slugifyUtmValue(value: string) {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function withUtmParams(href: string, params: UtmParams) {
  try {
    const url = new URL(href)

    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value)
      }
    })

    return url.toString()
  } catch {
    return href
  }
}
